export const routines = {
  getRoutines() {
    return this.httpInstance.get('/billing/routineShopItems');
  },
};
